import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import {
  CreatePaymentConditionRequest,
  ListPaymentConditionsQuery,
  PaymentCondition,
  PaymentConditionReduced,
  UpdatePaymentConditionRequest,
} from './PaymentCondition.types';

const CONTROLLER_URL = `${API_BASE_URL}/payment-conditions`;

export async function listPaymentsCondition(
  params?: ListPaymentConditionsQuery,
): Promise<PageResult<PaymentCondition>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<PaymentCondition>;
}

export async function listPaymentsConditionReduced(
  params?: ListPaymentConditionsQuery,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/reduced`,
    params,
  )) as unknown;

  return result as PageResult<PaymentConditionReduced>;
}

export async function createPaymentCondition(
  obj: CreatePaymentConditionRequest,
): Promise<PaymentCondition> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as PaymentCondition;
}

export async function updatePaymentCondition(
  obj: UpdatePaymentConditionRequest,
): Promise<PaymentCondition> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as PaymentCondition;
}

export async function deletePaymentCondition(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function paymentConditionId(
  id?: number,
): Promise<PaymentCondition> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, {})) as unknown;

  return result as PaymentCondition;
}

export async function activateOrInactivatePaymentCondition(
  paymentConditionId: number,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${paymentConditionId}/active`,
    {},
    null,
  )) as unknown;

  return result;
}
